import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import * as ContentActions from '../../../../actions/content'
import { notify as notifyAction } from '../../../../actions/notifications'
import { ContentTypes } from '../../../../constants'
import { Button, Column, Form, Input, ModalV1 } from '../../../../components'
import Media from './Media'
import { Box, MediaWrapper, DropBox, InputWrapperStyle, ScrollView, MediaHeader, FooterStyle } from './MultiMedia.style'
import { getUploadProgress } from '../../../../reducers/app'
import { MediaUtils } from '../../../../utils'

const { FormGroup } = Form

class MultiMedia extends PureComponent {
    mediaRefs = []
    uploadedData = []
    static propTypes = {
        channels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        fetchChannels: PropTypes.func.isRequired,
        fetchPlaylists: PropTypes.func.isRequired,
        isOpen: PropTypes.bool,
        onClickCancel: PropTypes.func,
        onFinishSubmit: PropTypes.func,
        t: PropTypes.func.isRequired,
        uploadProgress: PropTypes.number,
        currentfileName: PropTypes.string,
    }

    static defaultProps = {
        isOpen: false,
        onClickCancel: () => null,
        onFinishSubmit: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            files: [],
            isWorking: false,
            active: true,
        }
    }

    componentDidMount() {
        this.loadData()
    }

    async loadData() {
        const { resetUpload } = this.props
        resetUpload(ContentTypes.MEDIA)
    }

    onClickSubmit = () => {
        this.uploadedData = []
        this.setState({ isWorking: true })
        const validatedMedia = this.mediaRefs.map((ref) => ref.validate()).filter((flag) => flag)
        if (validatedMedia.length === this.mediaRefs.length) {
            this.mediaRefs.forEach((ref) => {
                ref.onSubmit()
            })
        }
    }

    innerOnChangeFile = (...args) => {
        const files = args?.[0]?.target?.files.length ? args?.[0]?.target?.files : []
        this.setState((preValue) => ({ files: [...preValue.files, ...files] }))
        files?.map(async (file) => {
            try {
                const { width, height } = await MediaUtils.getMediaResolution(file)
                const duration = await MediaUtils.getMediaDuration(file)
                this.addInfoToMedia(file.name, { duration, width, height })
            } catch (err) {
                console.log('error')
            }
        })

        this.setState({ active: false })
    }

    onFinishSubmit = async (data) => {
        const { onClickCancel, onFinishSubmit } = this.props
        const { files } = this.state
        this.uploadedData.push(data)
        if (this.uploadedData.length === files.length) {
            this.setState({ isWorking: false, files: [] })
            await onFinishSubmit(this.uploadedData)
            onClickCancel()
        }
        this.setState({ active: true })
    }
    onClickCancel = () => {
        const { onClickCancel } = this.props
        onClickCancel()
        if (!this.state.isWorking) {
            this.setState({ files: [] })
        }
    }

    onClicKRemoveMedia(index) {
        const files = [...this.state.files]
        files.splice(index, 1)
        this.setState({ files })
    }

    addInfoToMedia = (name, { duration, width, height }) => {
        const { files } = this.state
        const result = files.map((file) => {
            file.length = file.name === name ? duration * 1000 : file.length || 1000
            file.width = file.name === name ? width : file.width || 0
            file.height = file.name === name ? height : file.height || 0
            return file
        })
        this.setState({ files: result })
    }

    renderMedia = ({ file, index }) => {
        return (
            <Media
                onRef={(ref) => this.mediaRefs.push(ref)}
                file={file}
                onClickCancel={this.onClickCancel}
                onFinishSubmit={this.onFinishSubmit}
                onRemoveMedia={() => this.onClicKRemoveMedia(index)}
                key={index}
                index={index}
            />
        )
    }

    get progress() {
        const { progress } = this.props

        return Math.round(progress * 100)
    }
    render() {
        const { isOpen, t, uploadProgress, currentfileName } = this.props
        const { files, isWorking, active } = this.state
        this.mediaRefs = []
        return (
            <ModalV1 isOpen={isOpen} onClose={this.onClickCancel} width="700px" height="80%" progress={this.progress}>
                <MediaHeader>{t('Upload new media')}</MediaHeader>
                <DropBox>
                    <Input
                        id="file"
                        name="file"
                        type="file"
                        // error={!!errorFile}
                        onChange={this.innerOnChangeFile}
                        value={files}
                        accept="video/*,image/*,audio/*"
                        multiple
                        style={InputWrapperStyle}
                    />
                </DropBox>
                <ScrollView>
                    <MediaWrapper>
                        {files.map((file, index) => (
                            <Box key={index}>{this.renderMedia({ file, index })}</Box>
                        ))}
                    </MediaWrapper>
                </ScrollView>
                <FormGroup style={FooterStyle}>
                    <Column right width="100%">
                        <Box>{currentfileName}</Box>
                        <Button theme="secondary" onClick={this.onClickCancel} size="md">
                            {t('Cancel')}
                        </Button>
                        <Button theme={isWorking ? 'loading' : 'forestGreen'} onClick={this.onClickSubmit} size="md" disabled={active}>
                            {isWorking ? `${(uploadProgress * 100).toFixed(0)}%` : t('Upload media +')}
                        </Button>
                    </Column>
                </FormGroup>
            </ModalV1>
        )
    }
}

const mapStateToProps = (state) => {
    const {
        content: {
            form: { media: form },
            channels,
            playlists,
        },
    } = state

    return {
        form,
        channels,
        playlists,
        uploadProgress: getUploadProgress(state).progress,
        currentfileName: getUploadProgress(state).currentfileName,
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
            notify: notifyAction,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MultiMedia))
